import React from 'react';
import './cardHighlight.css';
import { Label } from '@nooz-optics/nooz-components-lib';
import {
  IBlock,
  IButton,
  ILabel,
  ILink,
} from '../../../utils/types/contentful';
import { Link } from '../../UI/Elements/Link';
import { formatContentfulComponentProps } from '../../../utils/globals';
import { Grid } from '../../UI/Grid/grid';
import {
  ImageCardShadow,
  ImageHighlight,
} from '../../UI/Cards/ImageHighlight/ImageHighlight';

export interface BlogHighlightProps {
  label: ILabel;
  cards: IBlock[];
  link: ILink;
  button: IButton;
}

export const CardHighlight = ({ cards, label, link, button }) => (
  <Grid
    grid={{
      header: (
        <div className='block lg:px-10 pb-7  w-full'>
          <div className='pt-6 w-full border-t xl:justify-between xl:flex'>
            <Label {...label} color={{ classname: 'gray-800' }} size='6xl' />
            {link && (
              <span className='mt-2 lg:mt-0'>
                <Link
                  {...link}
                  label={{
                    ...link.label,
                    icon: {
                      iconKey: 'HiChevronRight',
                      color: { classname: 'primary' },
                    },
                    color: { classname: 'primary' },
                    decoration: 'underline',
                  }}
                />
              </span>
            )}
          </div>
        </div>
      ),
      itemsWidth: 'min-w-10/12 sm-w-10/12 lg:min-w-1/3 lg:w-1/3',
      wrap: false,
      space: 'space-x-6',
      isSlider: 'block',
      gridItems: cards.items.map((card, index) => {
        const { article } = formatContentfulComponentProps(card);

        if (article) {
          const formatedBadges = [];

          if (article.categories) {
            for (let i = 0; i < article.categories.length; i++) {
              const category = article.categories[i];
              formatedBadges.push({
                ...category,
                icon: undefined,
                dotColor: category.color,
                label: category.label,
                type: 'white',
              });
            }
          }

          return (
            <ImageHighlight
              image={article.posterImage}
              label={article.label}
              badges={{ items: formatedBadges !== [] && formatedBadges }}
              subLabel={article?.subLabel}
              button={{
                ...button,
                type: 'outlined',
                slug: article.slug,
              }}
            />
          );
        } else {
          return <ImageHighlight {...formatContentfulComponentProps(card)} />;
        }
      }),
    }}
  />
);
